import React, { useEffect, useState } from 'react';
import { Card, Tag, Button, Modal, Popover, Form, Radio, Tooltip } from 'antd';
import './jobCard.scss';
import { LLMJobTag, UnderReviewTag } from './JobTags';
import { logJobDashboardActivity } from '../../shared/JobsApplied/Jobs';
import { connect } from 'react-redux';
import TextArea from "antd/lib/input/TextArea";
import JobsActions from "../../jobs/jobs.actions";
import { JobInterest } from '../../../../components/JobInterest';
import { COMPARE_STATUS, STATUS } from '../../../constants/status';
import { ReactComponent as InfoSvg } from '../../../../assets/img/info-outlined.svg';
import { ReactComponent as DescriptionSvg } from '../../../../assets/img/description.svg';
import { ReactComponent as ReadDescriptionSvg } from '../../../../assets/img/read_description.svg';
import { ReactComponent as DownArrowSvg } from '../../../../assets/img/down-arrow.svg';
import { ReactComponent as UpArrowSvg } from '../../../../assets/img/up-arrow.svg';
import { useJobModals } from '../../../../hooks/job-modal.actions';
import { useJobActions } from '../../../../hooks/job.actions';
import VetsmithConfirmationModal from './VetsmithConfirmationModal';
import removeParamFromUrl from '../../../util/removeParamFromURL';
import { TimelineSection } from './TimelineSection';
import { APPLICATION_STATUS_TO_TEXT, APPLICATION_STATUS } from '../constants';

function CurrentJob({ job = null, contents = {}, form, loadJobsV2, devStatus, useApplicationTrackingUI, panelKey }) {
  if (!job) return null;
  const [applyButtonClicked, setApplyButtonClicked] = useState(false)
  
  const [isOpenApplicationStatusDetail, setIsOpenApplicationStatusDetail] = useState(false);
  
  const {
    modalStates,
    modalActions
  } = useJobModals();
  
  const {
    loading,
    submittingNotInterested,
    handleJobApplication,
    handleNotInterested
  } = useJobActions(job, job.suggested);
  
  const { getFieldDecorator } = form;
  
  const {
    recommended_job_llm_tooltip = "Applying to this makes you eligible for multiple jobs.",
    recommended_job_llm_text = "Actively Hiring",
    recommended_job_application_under_review_text = "Applications under review",
    recommended_job_application_under_review_tooltip = "We’ve received the maximum number of applications for this position and we’re currently reviewing them. However, you can still apply, as we'll also consider your application for similar future jobs."
  } = contents;
  
  const {
    title = '',
    description = "",
    skills,
    status,
    featuredJob = false,
    jobCode,
    applicationReview = false,
    canResumeApplication,
    applicationStatus,
    applicationStatusMessage
  } = job;
  const unableToApply = COMPARE_STATUS(devStatus, STATUS.IN_TRIAL) >= 0 || [
    APPLICATION_STATUS.ARCHIVED,
    APPLICATION_STATUS.SUBMITTED,
    APPLICATION_STATUS.IN_REVIEW,
    APPLICATION_STATUS.REVIEW_COMPLETED,
    APPLICATION_STATUS.SHORTLISTED,
    APPLICATION_STATUS.SELECTED,
  ].includes(applicationStatus);
  const buttonText = canResumeApplication || applyButtonClicked ? 'Resume Application' : 'Start Application';
  const showButton = (["APPLIED", "APPLICATION_WITHDRAWN", "VETSMITH_FAILED"].includes(status) || unableToApply)  ? false : true;

  const queryParams = new URLSearchParams(location.search);
  const jobCodeForJD = queryParams.get('jobCodeForJD');

  useEffect(() => {
    if (jobCodeForJD && jobCodeForJD === jobCode) {
      modalActions.showModal();
      removeParamFromUrl('jobCodeForJD');
    }
  }, [jobCodeForJD]);

  const onButtonClick = () => {
    if (canResumeApplication) {
      logJobDashboardActivity('JOB_APPLICATIONS', 'CLICKED_ON_RESUME_APPLICATION_BUTTON', {
        jobId: job.id
      })
    } else {
      logJobDashboardActivity('JOB_APPLICATIONS', 'CLICKED_ON_JOB_APPLY_BUTTON', {
        jobId: job.id
      })
    }
    modalActions.hideModal();
    handleJobApplication({
        onShowJobRequestModal: (idHash, jobId) => {
            modalActions.setSelectedJobIdHash(idHash);
            modalActions.setSelectedJobId(jobId);
            modalActions.showJobRequestModal();
        },
        onOpenVetsmithModal: modalActions.openVetsmithConfirmationModal,
        onApplicationComplete: () => setApplyButtonClicked(true)
    });
  }

  const submitNotInterestedFeedback = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        handleNotInterested(values, () => {
          loadJobsV2();
        });
      }
    })
  }

  const renderButtons = () => {
    if (useApplicationTrackingUI) {
      return (
        <div className="job-buttons">
        {['submitted', 'archived'].includes(panelKey) && (
          <div
            className={`application-status application-status--${applicationStatus}`}
            onClick={() => setIsOpenApplicationStatusDetail(!isOpenApplicationStatusDetail)}
          >
            {APPLICATION_STATUS_TO_TEXT[applicationStatus]}
            {isOpenApplicationStatusDetail ? <UpArrowSvg /> : <DownArrowSvg />}
          </div>
          )}
          {(showButton || panelKey === 'archived') && (
            <Button
              size={"small"}
              className="job-description"
              type="default"
              onClick={() => {
                logJobDashboardActivity(
                  "JOB_APPLICATIONS",
                  "CLICKED_ON_JOB_DESCRIPTION_BUTTON",
                  {
                    jobId: job.id,
                  }
                );
                modalActions.showModal();
              }}
            >
              <DescriptionSvg />
            </Button>
          )}
          {!showButton && panelKey !== 'archived' && (
            <Button
              size={"small"}
              className="job-description"
              type="default"
              onClick={() => {
                logJobDashboardActivity(
                  "JOB_APPLICATIONS",
                  "CLICKED_ON_JOB_DESCRIPTION_BUTTON",
                  {
                    jobId: job.id,
                  }
                );
                modalActions.setSelectedJobIdHash(job.jobRequestCode);
                modalActions.setPreviewJrf(true);
                modalActions.showJobRequestModal();
              }}
            >
              <ReadDescriptionSvg fill="#0F0F0F" />
            </Button>
          )}
          {showButton && ["active", "recommended"].includes(panelKey) && (
            <Button
              className="apply"
              type="primary"
              loading={loading}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          )}
        </div>
      );
    }
    return (
      <div className="job-buttons">
        <Button
          size={"small"}
          className="job-description"
          type="default"
          onClick={() => {
            logJobDashboardActivity(
              "JOB_APPLICATIONS",
              "CLICKED_ON_JOB_DESCRIPTION_BUTTON",
              {
                jobId: job.id,
              }
            );
            modalActions.showModal();
          }}
        >
          <DescriptionSvg />
        </Button>
        {!showButton && (
          <Button
            className="view-application-btn"
            type="default"
            onClick={() => {
              logJobDashboardActivity(
                "JOB_APPLICATIONS",
                "CLICKED_ON_JOB_DESCRIPTION_BUTTON",
                {
                  jobId: job.id,
                }
              );
              modalActions.setSelectedJobIdHash(job.jobRequestCode);
              modalActions.setPreviewJrf(true);
              modalActions.showJobRequestModal();
            }}
          >
            View Application
          </Button>
        )}
        {showButton && (
          <Button
            className="apply"
            type="primary"
            loading={loading}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
        )}
      </div>
    );
  };

  const notInterestedPopoverContent = (
    <div className="not-interested-popover">
      <span className="popover-title">Why are you not interested in this job?</span>
      <Form onSubmit={submitNotInterestedFeedback}>
        <Form.Item>
          {getFieldDecorator('notInterestedReasonSystemName', {
            rules: [{ required: true, message: 'Please select a reason' }]
          })(
            <Radio.Group>
              <Radio value="skills_required_are_not_relevant_to_me">
                Skills required are not relevant to me
              </Radio>
              <Radio value="dont_have_required_experience">
                I don't have the required experience
              </Radio>
              <Radio value="dont_have_relevant_experience">
                I don't have relevant experience mentioned in job description
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('notInterestedFeedback')(
            <TextArea rows={3} placeholder="Enter feedback (Optional)"/>
          )}
        </Form.Item>
        <Form.Item>
          <Button loading={submittingNotInterested} className="submit-btn" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  )

  const showExtras = () => {
    if (!useApplicationTrackingUI) return true;
    if (['submitted', 'archived'].includes(panelKey)) return false;
    return true;
  }

  const renderTag = () => {
    if (!featuredJob) return null;
    return !useApplicationTrackingUI || (['active', 'recommended'].includes(panelKey))
  }

  const renderApplicationStatusDetail = () => {
    const styles = {
      transition: 'all 0.8s ease-in-out',
      opacity: 1,
      display: 'block',
    }
    if (!useApplicationTrackingUI || !['submitted', 'archived'].includes(panelKey) || !isOpenApplicationStatusDetail) {
      styles.opacity = 0;
      styles.display = 'none';
    }
    return (
      <div className="application-status-detail" style={styles}>
          <TimelineSection
            applicationStatus={applicationStatus}
            message={applicationStatusMessage}
            shouldShowTimeline={panelKey !== 'archived'}
          />
      </div>
    );
  }

  const renderNotInterestedPopover = () => {
    if (
      useApplicationTrackingUI &&
      ["submitted", "archived"].includes(panelKey)
    )
      return null;
    if (!["TODO", "VIEWED"].includes(status)) {
      return null;
    }
    return (
      <>
        <Popover
          placement="bottom"
          content={notInterestedPopoverContent}
          trigger="click"
        >
          <Button size="small" className="not-interested-btn" type="link">
            I'm not interested in this job
          </Button>
        </Popover>
        <span className="job-code-divider">.</span>
      </>
    );
  }

  return (
    <div className="job-card-v2-wrapper">
      <Card className="job-card current-job">
        <div className="job-card-body">
          <div className="job-info">
            <div className="job-card-header">
              <div
                className="title"
                data-length={title && title.length > 30 ? "long" : ""}
              >
                <h3>{title}</h3>
                {renderTag() && (
                  <LLMJobTag
                    text={recommended_job_llm_text}
                    tooltipText={recommended_job_llm_tooltip}
                  />
                )}
              </div>
              {applicationReview && (
                <UnderReviewTag
                  text={recommended_job_application_under_review_text}
                  tooltipText={recommended_job_application_under_review_tooltip}
                />
              )}
            </div>
            {showExtras() && (
              <div className="job-skills">
                {showButton && (
                  <div>
                    <span>Required Skills : </span>
                    {skills.map((skill, index) => (
                      <Tag key={`${skill.skillId}-${index}`} color="#F8F8F8">
                        {skill.skillName}
                      </Tag>
                    ))}
                  </div>
                )}
                <div>
                  {!showButton && (
                    <>
                      {status === "APPLIED" && (
                        <span className={`status status--${status}`}>
                          Application Submitted
                        </span>
                      )}
                      {status === "VETSMITH_FAILED" && (
                        <span className={`status status--${status}`}>
                          Failed Screening{" "}
                          <Tooltip title="If this is not right, reach out to support@turing.com">
                            <InfoSvg />
                          </Tooltip>
                        </span>
                      )}
                      {status === "APPLICATION_WITHDRAWN" && (
                        <span className={`status status--${status}`}>
                          Application Withdrawn
                        </span>
                      )}
                    </>
                  )}
                  {}
                </div>
              </div>
            )}
            <div className="job-code">
              {renderNotInterestedPopover()}
              {jobCode && (
                <>
                  <div className="jobCode">Job Id: {jobCode}</div>
                </>
              )}
            </div>
          </div>
          {renderButtons()}
        </div>
        {renderApplicationStatusDetail()}
      </Card>
      <Modal
        key="job-description"
        className="job-description-modal"
        title={
          <div className="job-description-header">
            <span>JOB DESCRIPTION</span>
            {showButton && (
              <Button
                className="apply"
                type="primary"
                loading={loading}
                onClick={onButtonClick}
              >
                {buttonText}
              </Button>
            )}
          </div>
        }
        visible={modalStates.isModalVisible}
        onCancel={modalActions.hideModal}
        footer={
          <div className="apply-btn-container">
            {showButton && (
              <Button
                className="apply"
                type="primary"
                loading={loading}
                onClick={onButtonClick}
              >
                {buttonText}
              </Button>
            )}
          </div>
        }
        width={700}
        bodyStyle={{ height: "100%", overflow: "auto" }}
      >
        <div className="jrf-container">
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></div>
        </div>
      </Modal>

      {modalStates.selectedJobIdHash && (
        <Modal
          key="job-description"
          title={
            modalStates.previewJrf
              ? "SUBMITTED APPLICATION"
              : "APPLY FOR THIS JOB OPPORTUNITY"
          }
          visible={modalStates.isJobRequestModalVisible}
          onCancel={modalActions.hideJobRequestModal}
          footer={null}
          className="full-width-modal"
        >
          <JobInterest
            jobId={modalStates.selectedJobId}
            hash={modalStates.selectedJobIdHash}
            preview={modalStates.previewJrf}
          />
        </Modal>
      )}

      {modalStates.vetsmithConfirmationModal && (
        <VetsmithConfirmationModal
          job={job}
          setVetsmithConfirmationModal={
            modalActions.closeVetsmithConfirmationModal
          }
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    jobs: {
      jobsV2: {
        jobsLoading = true
      } = {},
    } = {},
    home: {
      devStatus = ""
    } = {}
  } = state;
  return {
    jobsLoading,
    devStatus
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadJobsV2: () => dispatch(JobsActions.FETCH_JOBS_V2)
  }
}

export default Form.create({ name: 'not_interested_form' })(connect(mapStateToProps, mapDispatchToProps)(CurrentJob));
